(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cim-product-details-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cim-product-details')) {
        customElements.define('cim-product-details', class extends HTMLElement {
            connectedCallback() {
                this.mq = window.matchMedia('(max-width: 768px)');
                this.slots = [];
                this.querySelectorAll('[data-cim-details-item]').forEach((item) => {
                    const source = this.findSource(item.dataset.cimDetailsItem);
                    if (!source) return;
                    const placeholder = document.createComment('cim-details:' + item.dataset.cimDetailsItem);
                    source.before(placeholder);
                    this.slots.push({ item, source, placeholder, panel: item.querySelector('[data-cim-details-panel]') });
                    this.fillTexts(item, source);
                    item.querySelector('.cim-details-toggle').addEventListener('click', (event) => this.toggle(event.currentTarget));
                });
                if (!this.slots.length) return;
                this.sync = this.sync.bind(this);
                this.mq.addEventListener('change', this.sync);
                this.sync();
            }

            findSource(type) {
                if (type === 'description') return document.querySelector('.mm-adaptative-description');
                if (type === 'technology') return document.querySelector('.mm-section-section-tabs .mm-section-tabs');
                if (type === 'characteristics') {
                    const section = this.closest('.mm-section-caracteristiques');
                    const block = section && section.querySelector('.mm-caracteristiques');
                    return block && block.querySelector('.mm-caracteristiques-block') ? block : null;
                }
                return null;
            }

            fillTexts(item, source) {
                const preview = item.querySelector('[data-cim-details-preview]');
                const clean = (text) => (text || '').replace(/\s+/g, ' ').trim();
                if (item.dataset.cimDetailsItem === 'description') {
                    preview.textContent = clean(source.firstElementChild && source.firstElementChild.textContent);
                }
                if (item.dataset.cimDetailsItem === 'technology') {
                    const titles = [...source.querySelectorAll('[data-tab-title]')].map((title) => clean(title.textContent));
                    item.querySelector('[data-cim-details-title]').textContent = titles.join(' · ');
                    const description = source.querySelector('[data-tab-panel] .mm-section-tabs-description');
                    const first = description && [...description.querySelectorAll('p, li, h3, h4')].find((el) => clean(el.textContent));
                    const text = clean((first || description || {}).textContent);
                    preview.textContent = (text.match(/^.*?[.!?](\s|$)/) || [text])[0].trim();
                    // Titre de chaque panneau quand ils s'affichent à la suite (plusieurs technologies)
                    if (titles.length > 1) {
                        source.querySelectorAll('[data-tab-panel]').forEach((panel, index) => {
                            const subtitle = document.createElement('p');
                            subtitle.className = 'cim-details-subtitle';
                            subtitle.textContent = titles[index] || '';
                            panel.prepend(subtitle);
                        });
                    }
                }
            }

            toggle(button) {
                const open = button.getAttribute('aria-expanded') !== 'true';
                button.setAttribute('aria-expanded', open);
                document.getElementById(button.getAttribute('aria-controls')).hidden = !open;
            }

            sync() {
                const mobile = this.mq.matches;
                this.slots.forEach(({ item, source, placeholder, panel }) => {
                    if (mobile) panel.append(source);
                    else placeholder.after(source);
                    item.hidden = !mobile;
                });
                this.classList.toggle('is-mounted', mobile);
            }
        });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cim-sort-pill"] && !Shopify.designMode) return;
  try {
    (() => {
        if (window.cimSortReady) return;
        window.cimSortReady = true;

        const close = (wrapper, focus) => {
            const toggle = wrapper.querySelector('[data-cim-sort-toggle]');
            toggle.setAttribute('aria-expanded', 'false');
            wrapper.querySelector('[role="listbox"]').hidden = true;
            if (focus) toggle.focus();
        };
        const closeAll = (except) => {
            document.querySelectorAll('[data-cim-sort]').forEach((wrapper) => {
                if (wrapper !== except) close(wrapper, false);
            });
        };
        const open = (wrapper) => {
            closeAll(wrapper);
            wrapper.querySelector('[data-cim-sort-toggle]').setAttribute('aria-expanded', 'true');
            const list = wrapper.querySelector('[role="listbox"]');
            list.hidden = false;
            (list.querySelector('[aria-selected="true"]') || list.querySelector('[role="option"]')).focus();
        };
        const choose = (option) => {
            const wrapper = option.closest('[data-cim-sort]');
            const scope = option.closest('[data-section-collection-grid]') || document;
            const select = scope.querySelector('select[name="sort_by"]') || document.querySelector('select[name="sort_by"]');
            close(wrapper, true);
            if (!select || select.value === option.dataset.value) return;
            wrapper.querySelectorAll('[role="option"]').forEach((item) => item.setAttribute('aria-selected', item === option));
            wrapper.querySelectorAll('[data-cim-sort-current]').forEach((current) => current.textContent = option.textContent.trim());
            const dot = wrapper.querySelector('[data-cim-sort-dot]');
            if (dot) dot.hidden = option.dataset.value === dot.dataset.default;
            select.value = option.dataset.value;
            if (typeof window.mmSortByChanged === 'function') window.mmSortByChanged(select);
        };

        document.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-cim-sort-toggle]');
            const option = event.target.closest('[data-cim-sort] [role="option"]');
            if (toggle) {
                const wrapper = toggle.closest('[data-cim-sort]');
                if (toggle.getAttribute('aria-expanded') === 'true') close(wrapper, false);
                else open(wrapper);
            } else if (option) {
                choose(option);
            } else if (!event.target.closest('[data-cim-sort]')) {
                closeAll(null);
            }
        });

        document.addEventListener('keydown', (event) => {
            const option = event.target.closest && event.target.closest('[data-cim-sort] [role="option"]');
            if (!option) return;
            const wrapper = option.closest('[data-cim-sort]');
            const options = [...wrapper.querySelectorAll('[role="option"]')];
            const index = options.indexOf(option);
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                const next = options[(index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length];
                next.focus();
            } else if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                choose(option);
            } else if (event.key === 'Escape' || event.key === 'Tab') {
                close(wrapper, event.key === 'Escape');
            }
        });
    })();
  } catch(e) { console.error(e); }
})();

})();
